<template>
  <cs-modal v-model="shown" color-overlay="#b979e533" :content-position="contentPosition">
    <div slot="content-wrapper" class="modal-container">
      <div ref="scrollContent" class="modal-content">
        <h4 class="modal-title">{{ $t('you.want.turn.off.self.employed') }}</h4>
        <p class="modal-text" v-html="$t('restrictions.after.turn.off.self.employed')"></p>
        <div class="modal-button-container">
          <button class="modal-button success" @click="handleUnbind">
            {{ $t('common.yes') }}
          </button>
          <button class="modal-button cancel" @click="handleClose">
            {{ $t('common.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </cs-modal>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { mapGetters } from 'vuex';

export default {
  name: 'UnbindSelfEmployedModal',
  props: {
    value: Boolean,
  },
  data() {
    return {
      shown: false,
    };
  },
  computed: {
    contentPosition() {
      if (this.isDesktop) {
        return 'center';
      }
      return 'flex-end';
    },
    ...mapGetters(['isDesktop']),
  },
  watch: {
    value(val) {
      this.shown = val;
    },
    shown(val) {
      this.$emit('input', val);

      if (val) {
        disableBodyScroll(this.$refs.scrollContent);
      } else {
        enableBodyScroll(this.$refs.scrollContent);
      }
    },
  },
  methods: {
    async handleUnbind() {
      this.shown = false;
      await this.$nextTick();
      this.$emit('unbind');
    },
    handleClose() {
      this.shown = false;
    },
  },
};
</script>

<style lang="sass" scoped>
  .modal-container
    width: 100%
    background: #181823
    background-image: url("~@/assets/img/self-employed/what.png")
    background-repeat: no-repeat
    background-position: top 60px right

    +respond-to("small")
      width: 500px
      border-radius: 10px

  .modal-content
    padding: 20px

    +respond-to("small")
      padding: 50px 50px 40px

  .modal-title
    margin-bottom: 10px
    font-weight: 600
    font-size: 20px
    line-height: 30px
    color: #fff

    +respond-to("small")
      margin-bottom: 30px

  .modal-text
    margin-bottom: 30px
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff
    opacity: .75

    &::v-deep span
      display: inline-block

    +respond-to("small")
      padding-right: 35px

      &::v-deep span
        display: inline

  .modal-button-container
    display: flex
    flex-direction: column
    align-items: center

    +respond-to("small")
      flex-direction: row

  .modal-button
    width: 100%
    height: 50px
    font-weight: 600
    font-size: 18px
    line-height: 18px
    color: #fff
    border-radius: 50px

    +respond-to("small")
      width: 210px

    &.success
      margin-bottom: 20px
      background-color: #7CB342
      box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)

      +respond-to("small")
        margin-bottom: 0

    &.cancel
      background: #181823
</style>
